import Reveal from "./Reveal";
import SectionHeading from "./SectionHeading";
import { Clock, Timer } from "lucide-react";

const GENRES = [
  { name: "Motown / Soul", color: "text-hpink border-hpink/40 bg-hpink/10" },
  { name: "90s & Contemporary R&B", color: "text-horange border-horange/40 bg-horange/10" },
  { name: "Contemporary Top 40", color: "text-hblue border-hblue/40 bg-hblue/10" },
  { name: "Gospel / Inspirational", color: "text-hpink border-hpink/40 bg-hpink/10" },
  { name: "Pop/Rock Classics", color: "text-horange border-horange/40 bg-horange/10" },
  { name: "Musical Theatre", color: "text-hblue border-hblue/40 bg-hblue/10" },
];

const FORMATS = [
  {
    icon: Timer,
    title: "45-Minute Mainstage",
    sub: "Featured Set",
    desc: "A tight, high-impact feature set configured for mainstage slots and showcase programming.",
  },
  {
    icon: Clock,
    title: "3–4 Hour Lounge",
    sub: "Extended Acoustic Performance",
    desc: "Deep-catalog residencies and lounge engagements with self-accompanied acoustic guitar and vocals.",
  },
];

export default function Repertoire() {
  return (
    <section id="repertoire" className="relative py-24 lg:py-32 overflow-hidden" data-testid="repertoire-section">
      <div className="pointer-events-none absolute bottom-0 right-0 w-[460px] h-[460px] rounded-full bg-horange/10 blur-[140px]" />
      <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-16">
        <SectionHeading index="05" eyebrow="Repertoire & Vocal Styles" title="Six Genres, One Voice" />

        <div className="grid grid-cols-2 lg:grid-cols-3 gap-4">
          {GENRES.map((g, i) => (
            <Reveal key={g.name} delay={i * 0.06}>
              <div
                className={`h-full rounded-2xl border p-6 lg:p-8 font-display font-extrabold uppercase tracking-tight text-lg sm:text-xl lg:text-2xl transition-transform duration-300 hover:-translate-y-1 ${g.color}`}
                data-testid={`repertoire-chip-${i}`}
              >
                {g.name}
              </div>
            </Reveal>
          ))}
        </div>

        <div className="mt-8 grid md:grid-cols-2 gap-6">
          {FORMATS.map((f, i) => (
            <Reveal key={f.title} delay={i * 0.1}>
              <div
                className="h-full rounded-3xl border border-white/10 bg-white/[0.04] p-8 lg:p-10 flex gap-6 items-start transition-all duration-300 hover:border-hblue/40"
                data-testid={`format-card-${i + 1}`}
              >
                <div className="w-12 h-12 shrink-0 rounded-2xl bg-gradient-to-br from-hblue/20 to-hindigo/20 border border-hblue/30 flex items-center justify-center">
                  <f.icon size={20} className="text-hblue" />
                </div>
                <div>
                  <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-hdim">{f.sub}</p>
                  <h3 className="mt-1.5 font-display text-2xl font-extrabold tracking-tight">{f.title}</h3>
                  <p className="mt-3 text-hmut leading-relaxed">{f.desc}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.15}>
          <p className="mt-8 text-hdim text-sm leading-relaxed max-w-3xl">
            Working catalog: an extensive multi-genre library configured for both 45-minute mainstage
            featured sets and 3- to 4-hour lounge/acoustic performances.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
